<template>
    <a
        class="search-result-contact"
        :data-bot="context ? `search-result__contact--${context}` : 'search-result__contact'"
        :class="classes"
        :href="link"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
        v-on="$listeners"
    >
        <CompassObject size="extra-small" type="object" object="contact" />
        <div class="search-result-contact__content">
            <h5
                class="search-result-contact__name typographies-paragraph-medium-bold"
                v-html="name"
            />
            <p
                class="search-result-contact__company typographies-paragraph-medium-semibold"
                v-if="companies.length > 0"
            >
                <ContactLinkedCompanies :companies="companies" />
            </p>
            <div
                v-for="(extraField, index) in getHighlightedExtraFields"
                :key="index"
                class="typographies-paragraph-medium-regular search-result-contact__extra-field"
            >
                <span> {{ extraField.label }}</span>
                <span v-html="extraField.value" />
            </div>
        </div>
    </a>
</template>
<script>
import ContactLinkedCompanies from './ContactLinkedCompanies.vue';
import SearchResultsGeneric from './SearchResultsGeneric.vue';

export default {
    components: { ContactLinkedCompanies },
    extends: SearchResultsGeneric,
    props: {
        companies: {
            type: Array,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        position: {
            type: String,
            default: '',
        },
    },
    computed: {
        classes() {
            return {
                'search-result-contact--is-hovered': this.isHovered,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-contact {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-3);

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__company {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        margin: var(--spacing-0) 0 0;
    }

    ::v-deep .highlight {
        background: var(--colors-common-background-warning-subtle);
    }

    ::v-deep .compass-link {
        display: inline;
    }

    &__extra-field {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-0);
        padding: var(--spacing-0) 0 0;
    }
}
</style>
